<template>
    <div class="">
        <b-modal content-class="modal-fullscreen" id="modal-call"
                 centered
                 scrollable
                 no-close-on-backdrop
                 hide-footer
                 hide-header>
            <div class="">


                <div class="card bg-transparent text-center">
                    <div class="card-body ">
                        <img class="icon mb-3" src="../assets/images/fail.png">


                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-auto message-body">
                                <div class="mb-3"> Account Alert</div>
                                <div class="text-secondary"> We can't find your email and phone number?
                                    Please contact our <span @click="confirm"><u> Call center</u></span> to update your information.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row no-gutters">
                    <div class="col-4">
                        <div class="btn btn-secondary w-100 no-radius btn-lg" @click="close">
                            CANCEL
                        </div>
                    </div>
                    <div class="col">
                        <div class="btn btn-primary w-100 no-radius btn-lg" @click="confirm">
                            CALL
                        </div>
                    </div>
                </div>

            </div>


        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'CallDialog',
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            async close() {
                this.$bvModal.hide('modal-call');
            },
            async confirm() {
                this.$bvModal.hide('modal-call');
                window.location.href = "tel:026585050";
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/css/colors";

    #modal-call .modal-body {
        background-color: $black !important;
        padding: 0;
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.7) !important;
    }

    #modal-call .modal-content {
        background: transparent;
    }

    #modal-call .message-body {
        max-width: 400px;
    }

</style>
